import { NbDialogService, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { ManagementsService } from '../../services/managements-service';
import { AddManagementComponent } from '../add/add-management/add-management.component';
import { GetManagementDetailsComponent } from '../get-management-details/get-management-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PagingService } from '../../../../shared/Services/PagingService';
import { ConfirmationDialogComponent } from '../../../../shared/Components/confirmation-dialog.component';

@Component({
  selector: 'app-get-managements',
  templateUrl: './get-managements.component.html',
  styleUrls: ['./get-managements.component.scss'],
})
export class GetManagementsComponent extends BaseComponent implements OnInit {

  form:FormGroup


  constructor(
    public service: ManagementsService,
    route: Router,
    private fb:FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private paging: PagingService,
    public dialog: NbDialogService // Change type to NbDialogService
  ) {
    super(route, service, paging);
  }


  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }

  initForm() {
    this.form = this.fb.group({
      code: ['']
    });
  }

  handleSearch() {

    if ( this.form.value.code == '') {
      this.toast.danger('برجاءاختيار الاسم لاتمام عملية البحث', 'رساله تحذيرية');
    }
    else {

    let searchTerm = `code:${this.form.value.code.trim()}`;
    this.loadEntitiesWithFilter(searchTerm)
  }

  }

  clearFilter(){
    this.form.controls['code'].setValue('');
    this.loadEntitiesWithFilter('')
  }


  addNewManagement() {
    this.diag
      .open(AddManagementComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

  detail(model) {
    this.diag.open(GetManagementDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  delete(id) {
    this.dialog
      .open(ConfirmationDialogComponent, {
        context: { message: 'Are you sure you want to delete this item?' } as Partial<ConfirmationDialogComponent>, // Ensure type compatibility
      })
      .onClose.subscribe((result) => {
        if (result) {
          this.service.delete(id).subscribe(() => {
            this.toast.show('تم الحذف  بنجاح', '', { status: 'success', duration: 3000 });
            this.loadEntities();
          });
        }
      });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddManagementComponent, {       
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
